module.exports = __webpack_public_path__ + "static/media/assistants-big.a050f1e0.svg";